import React, { Fragment } from 'react'
import { Heading } from '@myxplor/ui'

export const NoReports = () => (
  <Fragment>
    <Heading small>No Reports</Heading>
    There are no reports available for you to use
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/provider-level/reports/views/empty.jsx